import { Injectable } from '@angular/core';
import { finalize, Observable } from 'rxjs';
import { v4 as uuid } from 'uuid';

@Injectable({ providedIn: 'root' })
export class ChangeHistoryService {
  private static operationId: string;

  public static setHeaders<T>(func: () => Observable<T>): Observable<T> {
    this.operationId = `${new Date().getTime()}_${uuid()}`;
    return func().pipe(
      finalize(() => {
        this.operationId = null;
      }),
    );
  }

  public static getHeaders(): object {
    return { 'change-history-operation-id': this.operationId };
  }
}
